import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute z-20 mt-1 w-full min-w-[220px] bg-white border border-dashboard-border rounded-lg shadow-lg p-2 max-h-72 overflow-auto"
}
const _hoisted_2 = {
  key: 0,
  class: "flex items-center gap-1 mb-2"
}
const _hoisted_3 = ["value", "checked", "onChange"]
const _hoisted_4 = { class: "truncate" }
const _hoisted_5 = {
  key: 2,
  class: "text-xs text-dashboard-muted px-2 py-1"
}
const _hoisted_6 = {
  key: 3,
  class: "mt-2 pt-2 border-t border-dashboard-border flex justify-between items-center"
}
const _hoisted_7 = { class: "text-xs text-dashboard-muted" }

import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { ChevronDown } from 'lucide-vue-next'

interface Option { value: string; label: string }


export default /*@__PURE__*/_defineComponent({
  __name: 'MultiSelectDropdown',
  props: {
    label: {},
    options: {},
    modelValue: {},
    mode: { default: 'include' },
    showMode: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "update:mode"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const root = ref<HTMLElement | null>(null)
const open = ref(false)
const query = ref('')

const selected = computed(() => props.modelValue || [])

const filteredOptions = computed(() => {
  const q = query.value.trim().toLowerCase()
  if (!q) return props.options
  return props.options.filter((o) => o.label.toLowerCase().includes(q))
})

const summary = computed(() => {
  const n = selected.value.length
  if (!n) return props.label
  const prefix = props.showMode && props.mode === 'exclude' ? 'Exclure ' : ''
  if (n === 1) {
    const opt = props.options.find((o) => o.value === selected.value[0])
    return prefix + (opt?.label || '1 sélectionnée')
  }
  return `${prefix}${n} sélectionnées`
})

function toggle(value: string) {
  const set = new Set(selected.value)
  set.has(value) ? set.delete(value) : set.add(value)
  emit('update:modelValue', [...set])
}
function clearAll() {
  emit('update:modelValue', [])
}

function onClickOutside(e: MouseEvent) {
  if (open.value && root.value && !root.value.contains(e.target as Node)) open.value = false
}
onMounted(() => document.addEventListener('click', onClickOutside))
onBeforeUnmount(() => document.removeEventListener('click', onClickOutside))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "relative",
    ref_key: "root",
    ref: root
  }, [
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = !open.value)),
      class: "w-full px-2 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm flex items-center justify-between gap-1"
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["truncate", selected.value.length ? 'text-dashboard-text' : 'text-dashboard-muted'])
      }, _toDisplayString(summary.value), 3),
      _createVNode(_unref(ChevronDown), { class: "w-4 h-4 flex-shrink-0 text-dashboard-muted" })
    ]),
    (open.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.showMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:mode', 'include'))),
                  class: _normalizeClass(['flex-1 px-2 py-1 rounded-md text-xs font-medium border transition-colors',
                   _ctx.mode !== 'exclude' ? 'bg-emerald-600 text-white border-emerald-600' : 'bg-white text-dashboard-text border-dashboard-border'])
                }, "Inclure", 2),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:mode', 'exclude'))),
                  class: _normalizeClass(['flex-1 px-2 py-1 rounded-md text-xs font-medium border transition-colors',
                   _ctx.mode === 'exclude' ? 'bg-red-600 text-white border-red-600' : 'bg-white text-dashboard-text border-dashboard-border'])
                }, "Exclure", 2)
              ]))
            : _createCommentVNode("", true),
          (_ctx.options.length > 8)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((query).value = $event)),
                type: "text",
                placeholder: "Filtrer…",
                class: "w-full mb-2 px-2 py-1 border border-dashboard-border rounded-md text-xs"
              }, null, 512)), [
                [_vModelText, query.value]
              ])
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (opt) => {
            return (_openBlock(), _createElementBlock("label", {
              key: opt.value,
              class: "flex items-center gap-2 px-2 py-1.5 rounded-md hover:bg-dashboard-bg cursor-pointer text-sm"
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                value: opt.value,
                checked: selected.value.includes(opt.value),
                onChange: ($event: any) => (toggle(opt.value))
              }, null, 40, _hoisted_3),
              _createElementVNode("span", _hoisted_4, _toDisplayString(opt.label), 1)
            ]))
          }), 128)),
          (!filteredOptions.value.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Aucune option."))
            : _createCommentVNode("", true),
          (selected.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(selected.value.length) + " sélectionnée(s)", 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: clearAll,
                  class: "text-xs text-red-600 hover:underline"
                }, "Tout retirer")
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})